import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { isSuperUserOrGroupAdmin } from 'store/session/selectors';

import {
  fetchAPIToken,
  generateNewAPIToken,
  revokeAPIToken,
  types,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.GENERATE_NEW_API_TOKEN_REQUEST,
    watchGenerateNewAPIToken,
  );
  yield takeLatest(types.REVOKE_API_TOKEN_REQUEST, watchRevokeAPIToken);
}

function* watchFetchAPIToken() {
  try {
    const isSuperUserOrUserGroupAdmin = yield select(isSuperUserOrGroupAdmin);
    let apiToken = null;
    if (isSuperUserOrUserGroupAdmin) {
      const apiTokenResult = yield call(API.integrations.getAPIToken);
      apiToken = apiTokenResult.apiToken;
    }
    yield put(fetchAPIToken.success({ apiToken }));
  } catch (error) {
    yield put(fetchAPIToken.error(error));
  }
}

function* watchGenerateNewAPIToken() {
  try {
    const { apiToken } = yield call(API.integrations.postAPIToken);
    yield put(generateNewAPIToken.success({ apiToken }));
  } catch (error) {
    yield put(generateNewAPIToken.error(error));
  }
}

function* watchRevokeAPIToken() {
  try {
    yield call(API.integrations.deleteAPIToken);
    yield put(revokeAPIToken.success());
  } catch (error) {
    yield put(revokeAPIToken.error(error));
  }
}

export function* initSaga() {
  yield call(watchFetchAPIToken);
}
